import { Link } from "react-router-dom";
import { allCategories } from "@/lib/news";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-accent-950">
                <i className="ri-eye-2-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                黑料官网
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-300">
              黑料官网定位为权威黑料信息聚合与解析平台，提供最新动态、社会热点与多维度深度内容，帮助用户快速发现并理解热门话题。
            </p>
            <p className="mt-4 text-xs text-background-400">
              本站为演示站点，全部内容为虚构示例，不涉及任何真实人物、机构或事件。
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50">
              内容分类
            </h2>
            <ul className="mt-4 space-y-2 text-sm">
              {allCategories.map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-background-300 transition-colors hover:text-accent-300 cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-semibold text-background-50">
              关于本站
            </h2>
            <ul className="mt-4 space-y-2 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300" />
                contact@heikao-demo.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-300" />
                内容更新：每日
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-300" />
                线上信息聚合平台
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center">
          <p>© 2026 黑料官网 · 演示项目，仅供展示页面与交互效果</p>
          <p>免责声明：本站内容均为虚构示例，请勿据此对任何真实主体作出判断。</p>
        </div>
      </div>
    </footer>
  );
}